<div class="payments-container">
  <div class="card shadow-sm border-0 rounded-4 mb-4">
    <div class="card-body p-3">
      <h5 class="fw-semibold text-secondary mb-3">Payments</h5>

      <ng-template #loadingPayments>
        <p class="text-muted">Loading payments...</p>
      </ng-template>

      <ng-template #noPayments>
        <p class="text-muted fst-italic">No payments found.</p>
      </ng-template>

      <div *ngIf="payments$ | async as payments; else loadingPayments">
        <div *ngIf="payments.length > 0; else noPayments">

          <div
            *ngFor="let payment of payments; trackBy: trackPayment"
            class="payment-row"
          >
            <!-- LEFT -->
            <div class="payment-left">
              <div class="amount">
                {{ payment.amountinCents | currency:'USD':'symbol':'1.2-2' }}
              </div>
              <div class="date">
                {{ payment.createdAtFormatted }}
              </div>
            </div>

            <!-- RIGHT GROUP -->
            <div class="payment-right">
              <div class="meta">
                <span
                  class="badge"
                  [ngClass]="
                    payment.status === 'succeeded' ? 'bg-success' :
                    payment.status === 'pending' ? 'bg-warning text-dark' :
                    'bg-danger'
                  "
                >
                  {{ payment.status | titlecase }}
                </span>

                <span class="method">
                  {{ payment.paymentMethod === 'us_bank_account'
                    ? 'Bank'
                    : payment.paymentMethod | titlecase }}
                </span>
              </div>

              <button
                *ngIf="payment.brandedReceiptUrl"
                class="btn btn-outline-primary btn-sm download-btn"
                (click)="downloadReceipt(payment.brandedReceiptUrl)"
                aria-label="Download receipt"
              >
                <i class="bi bi-download"></i>
              </button>

              <span
                *ngIf="!payment.brandedReceiptUrl"
                class="pending-text"
              >
                Pending
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>